import React, {useEffect, useState} from "react";
import {Loading, useGetOne} from "react-admin";
import ErrorIcon from "@mui/icons-material/Report";
import {ApplicationRegistrationForm} from "./ApplicationRegistrationForm";

const ApplicationRegistration = () => {
  const [url, setUrl] = useState(null);
  const [splitData, setSplitData] = useState<string[]>([]);
  useEffect(() => {
    const url = window.location.href;
    const parts = url.split("/cp/");
    const extractedUrl: any = parts[1];
    setUrl(extractedUrl);
    const splitValue: any = url.split("/");
    setSplitData(splitValue);
  }, []);
  const { data, error: registrationError, isLoading: registrationLoading } = useGetOne(
    "registrationpage",
    { id: url },
    // { refetchOnWindowFocus: false }
    { enabled: url ? true : false, refetchOnWindowFocus: false },
  );
  if (registrationLoading) return <Loading />
  if (registrationError) return (
    <div style={{
      display: "flex",
      flexDirection: "column",
      alignItems: "center",

      gap: "20px", // Adjust the gap value as needed
      marginTop: "20px",
      textAlign: "center"
    }}>
      <h3>
        {splitData[5]} Not Available
      </h3>
      <ErrorIcon style={{ fontSize: 150 }} />
      <div>
        {`${registrationError}`?.split(":")[1]?.trim()}
      </div>
    </div>
  );

  return (
    <><ApplicationRegistrationForm data={data} splitData={splitData} /></>);
}

export default ApplicationRegistration;
